const createPager = require('lib/more-results');
const createReadMore = require('lib/read-more');
import { isMobile } from 'lib/utils';

createPager('.results-list', '.btn-load-more', {
    initialResults: window.NL.litigationResults,
    initialPage: 0,
    resultTemplate: _.template("<li><strong><%= amount %> - <%= title %></strong> <p><%= description %></p></li>")
});

$('.more-results .results-list li .inner-text').each(function() {
    createReadMore(this, {
        maxChars: isMobile() ? 150 : 300
    });
});


// WEBPACK FOOTER //
// ./assets/js/app/pages/our-results.js